
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import Icon from "@/components/UI/Icon.vue";
import { pipe } from "fp-ts/function";
import { fold } from "fp-ts/Either";
import NiceButton from "@/components/UI/NiceButton.vue";
import { configStore, globalStore, uiStore } from "@/store/store-accessor";
import { makeWordPressAjaxRequest } from "@/lib/wordpress/ajax";
import NotificationLogger from "@/lib/notifications/notifications";
import LoadingSpinner from "@/components/Reusable/LoadingSpinner.vue";
import { DesignProvider } from "@/types/design-library";
import { ElementPresetsV } from "@/types/presets";

@Component({
  components: {
    Icon,
    NiceButton,
    LoadingSpinner
  }
})
export default class DesignLibraryDesignPresets extends Vue {
  @Prop({ default: null })
  provider!: DesignProvider | null;

  @Prop({ default: null })
  lastImportedFromUrl!: string | null;

  loading = false;
  showImportScreen = false;

  async importSettings() {
    if (this.provider?.isLocal) return;

    this.loading = true;

    const url = this.provider?.url;

    const newSettings = pipe(
      await makeWordPressAjaxRequest({
        action: "breakdance_get_external_design_presets",
        decoder: ElementPresetsV,
        friendlyName: `Design Presets for "${url}"`,
        dataToPost: { url }
      }),
      fold(
        () => null,
        newSettings => {
          if (url) {
            configStore.setDesignLibrary({
              ...configStore.designLibrary,
              designPresetsLastImportedFromUrl: url
            });
          }
          return newSettings;
        }
      )
    );

    this.loading = false;
    this.showImportScreen = false;

    if (!newSettings) {
      NotificationLogger.log.errorMessage(
        `Error importing Design Presets for "${
          this.provider?.name || this.provider?.url
        }"`
      );

      return;
    }

    globalStore.setPresets(newSettings);
    uiStore.setShouldPanelLoadFreshDataIntoStoreOnceOpened("presets", false);

    NotificationLogger.log.message(
      `Imported Design Presets from "${
        this.provider?.name || this.provider?.url
      }"`
    );
  }

  toggleImportScreen() {
    this.showImportScreen = !this.showImportScreen;
  }
}
